import DataType from '@opsbase/lib-datatype/DataType';
import doNothing from '@opsbase/lib-general/utils/doNothing';
import i18n from '@opsbase/lib-i18n';
import Palette from '@opsbase/lib-palette';
import DataPill from '@opsbase/web-chips/DataPill';
import Vertical from '@opsbase/web-layout/Vertical';
import Text from '@opsbase/web-ui/Text';
import React from 'react';
import TemplateList from '../../../../shared/UX/TemplateChooser/TemplateList';
const styles = {
    container: {
        borderRadius: 3,
        backgroundColor: Palette.White.main,
        border: `1px solid ${Palette.InputBorderGrey.main}`,
    },
    padding20: {
        padding: 20,
    },
    padding2: {
        padding: 2,
    },
};
export function PickTemplate(props) {
    const { systemDataSettings } = props;
    return (React.createElement(Vertical, { gutter: true, paddingX: true },
        React.createElement(Text, { variant: 'h1' }, i18n.t('op-templates')),
        React.createElement(Text, null, i18n.t('op-template-line1')),
        React.createElement(Text, null, i18n.t('op-template-line2')),
        React.createElement(Text, null, i18n.t('op-template-line3')),
        React.createElement("div", { style: { ...styles.container, ...styles.padding20 } },
            React.createElement("div", { style: { ...styles.container, ...styles.padding2 } },
                React.createElement(DataPill, { large: true, type: DataType.TEMPLATE, value: systemDataSettings ? systemDataSettings.opDefinitionTemplate.title : '' })),
            React.createElement("div", { style: {
                    ...styles.container,
                    marginTop: 10,
                    height: 100,
                    borderLeft: '0px',
                } },
                React.createElement(TemplateList, { data: systemDataSettings ? [systemDataSettings.opDefinitionTemplate] : [], selected: systemDataSettings ? [systemDataSettings.opDefinitionTemplate] : [], onSelect: doNothing })))));
}
export default PickTemplate;
